import { graphql } from 'react-relay';

export const ChargeAddCustomer = graphql`
  mutation ChargeAddCustomerMutation($input: ChargeAddCustomerInput!) {
    ChargeAddCustomer(input: $input) {
      error
      charge {
        ...Payment_charge
      }
    }
  }
`;
